import { ArrowUpRight } from "lucide-react";
import { howItWorks } from "@/constants/content";
import { BUYER_FORM_URL } from "@/constants/links";
import { MaskedLine, FadeIn } from "@/components/Reveal";

export default function HowItWorks() {
  return (
    <>
      <section data-testid="how-it-works-page" className="relative overflow-hidden pb-14 pt-32 sm:pt-40 lg:pt-48">
        <div className="pointer-events-none absolute -top-24 right-[-8%] h-[26rem] w-[26rem] rounded-full bg-[#1E3A8A]/10 blur-[110px]" aria-hidden="true" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
          <p className="eyebrow" data-testid="how-it-works-eyebrow">The Planned Experience</p>
          <h1 className="mt-8 font-sans text-4xl font-bold leading-[1.08] tracking-tight text-[#0F172A] sm:text-5xl lg:text-6xl">
            <MaskedLine delay={0.15}>How AFLIMART</MaskedLine>
            <MaskedLine delay={0.3} className="text-gold-gradient">Works</MaskedLine>
          </h1>
        </div>
      </section>

      <section data-testid="how-it-works-steps" className="mx-auto max-w-7xl px-4 pb-20 sm:px-8 lg:px-16">
        <div>
          {howItWorks.map((s, i) => (
            <FadeIn key={s.n} delay={0.06 * i}>
              <div data-testid={`how-page-step-${i + 1}`} className="group grid grid-cols-1 gap-3 border-t border-[#E2E8F0] py-8 transition-colors duration-500 hover:border-[#1E3A8A]/30 sm:grid-cols-12 sm:items-baseline sm:gap-8">
                <span className="font-sans text-sm tracking-[0.25em] text-[#1E3A8A] sm:col-span-2">{i + 1}.</span>
                <h2 className="font-sans text-xl text-[#0F172A] transition-colors duration-500 group-hover:text-[#1D4ED8] sm:col-span-4 sm:text-2xl">{s.title}</h2>
                <p className="text-sm leading-relaxed text-[#64748B] sm:col-span-6 sm:text-base">{s.copy}</p>
              </div>
            </FadeIn>
          ))}
          <div className="border-t border-[#E2E8F0]" />
        </div>
        <FadeIn delay={0.2}>
          <a href={BUYER_FORM_URL} target="_blank" rel="noopener noreferrer" data-testid="how-it-works-cta" className="btn-gold mt-12">
            Join the Buyer Waitlist <ArrowUpRight size={16} />
          </a>
        </FadeIn>
      </section>
    </>
  );
}
